import {
  CalendarDate,
  endOfMonth,
  startOfMonth,
} from '@internationalized/date';
import { CalendarState } from './useCalendarState';

/**
 * Creates an array filled with numbers from {@param start} to {@param end}
 */
export function range(start: number, end: number): number[] {
  return Array(end - start + 1)
    .fill(null)
    .map((_, index) => start + index);
}

/**
 * Converts an array into chunks
 * @returns iterator of the chunks
 */
export function* chunks<T>(
  array: T[],
  chunkSize: number
): Generator<T[], void> {
  for (let i = 0; i < array.length; i += chunkSize) {
    yield array.slice(i, i + chunkSize);
  }
}

/**
 * Uppercases the first letter in the string
 * @param sentence
 * @returns sentence with first letter upper cased
 */
export const sentenceCase = (sentence: string): string =>
  sentence.slice(0, 1).toLocaleUpperCase() + sentence.slice(1);

/**
 * Checks if a month should be disabled.
 * A month is disabled if:
 * 1. It falls outside the min/max date range (invalid range), OR
 * 2. All days in the month are unavailable
 */
export function isMonthDisabled<T extends string>(
  month: CalendarDate,
  state: CalendarState<T>
): boolean {
  const monthStart = startOfMonth(month);
  const monthEnd = endOfMonth(month);

  const isInvalidRange =
    state.isInvalid(monthStart) &&
    state.isInvalid(monthEnd) &&
    state.isInvalid(month);

  let current = monthStart;
  while (current.compare(monthEnd) <= 0) {
    if (!state.isCellUnavailable(current)) {
      return isInvalidRange;
    }
    current = current.add({ days: 1 });
  }

  return true;
}
